<kuv-alert></kuv-alert>
<kuv-loading></kuv-loading>

<div class="container-fluid p-5">
    <h3>Gestión de Conceptos</h3>
    <button class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nuevo Concepto</button>
    <br>
    <kuv-lazy-table [url]="config.apiUrl + 'tipo-revision/index'" [headers]="sesion.headers" [isRounded]="true"
        [hasShadow]="true" [reloadEmitter]="reloadEmitter" [acciones]="actions" [columnas]="columns"
        [filtros]="filters"></kuv-lazy-table>
</div>